import { createContext, useState, useEffect } from 'react';

import { storeObject, getObject } from '../apiClients/apiClient';

const AuthContext = createContext(null);

const tokensStorageKey = 'authTokens';

function AuthContextProvider({ children }) {
    const [isLoadingAuthState, setIsLoadingAuthState] = useState(true);
    const [tokens, setTokens] = useState({});
    const [loginOtpRequest, setLoginOtpRequest] = useState(null);
    const [signUpRequest, setSignUpRequest] = useState(null);

    const loadTokensFromDisk = async () => {
        const storedTokens = await getObject(tokensStorageKey);
        if (storedTokens === null) {
            setTokens({});
            setIsLoadingAuthState(false);
            return;
        }

        setTokens(storedTokens);
        setIsLoadingAuthState(false);
    };

    const storeTokensToDisk = async () => {
        await storeObject(tokensStorageKey, tokens);
    };

    useEffect(() => {
        loadTokensFromDisk();
    }, []);

    useEffect(() => {
        if (isLoadingAuthState) {
            return;
        }

        storeTokensToDisk();
    }, [isLoadingAuthState, tokens]);

    useEffect(() => {
        console.log('Tokens updated');
        console.log(tokens);
    }, [tokens]);

    return (
        <AuthContext.Provider
            value={{
                tokens: tokens,
                setTokens: setTokens,
                loginOtpRequest: loginOtpRequest,
                setLoginOtpRequest: setLoginOtpRequest,
                signUpRequest: signUpRequest,
                setSignUpRequest: setSignUpRequest,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

const AUTH_STATES = null;

export default AuthContextProvider;
export { AuthContext, AUTH_STATES };
